export default __webpack_public_path__ + "static/media/avatar-normal-geometric-11.5088d0dd.svg";